import { listStyles } from "@insite/content-library/Widgets/ProductList/ProductListCardList";
import merge from "lodash/merge";
import { css } from "styled-components";

Object.assign(listStyles, {
    wrapper: {
        css: css`
            margin-top: 20px;
            border-top: 0;
        `,
    },
    cardContainerStyles: {
        cardDivider: {
            css: css`
                width: 100%;
                border-bottom: 0;
                margin-right: 20px;
            `,
        },
        gridItem: {
            css: css`
                border-bottom: 0;
            `,
        },
    },
    cardContainerMultiColumnStyles: {
        cardDivider: {
            css: css`
                border-bottom: 0;
                padding: 0 20px 20px 0px;
                height: 100%;
                width: 100%;
                overflow: hidden;
            `,
        },
        gridItem: {
            width: [12, 12, 6, 4, 4],
            css: css`
                padding: 0;
            `,
        },
    },
});
